import { Construction } from "lucide-react";

export default function UnderDevelopmentRibbon() {
  return (
    <div
      data-testid="under-development-ribbon"
      className="fixed top-0 left-0 right-0 z-[60] h-8 md:h-9 flex items-center justify-center bg-gradient-to-r from-[#003771] via-[#1E96FC]/25 to-[#003771] border-b border-[#1E96FC]/40"
    >
      <div className="flex items-center gap-2 md:gap-3 px-4">
        <span className="relative flex h-1.5 w-1.5 md:h-2 md:w-2 shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#1E96FC] opacity-60" />
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 md:h-2 md:w-2 bg-[#1E96FC]" />
        </span>
        <Construction className="w-3 h-3 md:w-3.5 md:h-3.5 text-[#1E96FC] shrink-0" />
        <span className="text-[9px] md:text-[10px] lg:text-[11px] font-semibold uppercase tracking-[0.18em] md:tracking-[0.28em] text-slate-200 truncate">
          <span className="text-white">Under Development</span>
          <span className="text-slate-500 mx-2">·</span>
          <span>Commercial launch — 2027</span>
        </span>
      </div>
    </div>
  );
}
